/**
 * The error codes the API can return, shared so both sides agree on the strings.
 *
 * Before this existed the API kept its own union and the browser kept none —
 * `ApiErrorBody.code` was a plain `string`, so `error.code === 'version_publishd'`
 * would have compiled on either side and simply never matched. Nothing caught a
 * typo in either direction (T3.15a).
 *
 * These are a contract with the browser, not internal labels. Renaming one is a
 * breaking change; adding one is not.
 */
export const ERROR_CODES = [
    /** The request body, params or query failed schema validation. */
    'validation_failed',
    /** No session, or one that has expired. */
    'unauthenticated',
    /** Wrong email or password. Deliberately the same for both. */
    'invalid_credentials',
    /** Authenticated, and not permitted. Only used where the caller already knows the resource exists. */
    'forbidden',
    /** Absent, or present and withheld — the two are indistinguishable by design (D-21). */
    'not_found',
    /** A generic state conflict. */
    'conflict',
    /**
     * A write lost a race with a publish: the version it named is now published.
     * Distinct from `conflict` so the browser can refetch the new draft and say
     * what happened, rather than reporting a bare failure (design.md § 6).
     */
    'version_published',
    /**
     * A backdated publish names a week that already holds a backdated version
     * (design.md § 10a, 7.4). Distinct from `conflict` so the browser can name
     * the version already there and offer to supersede it, rather than reporting
     * a bare failure. ORDINARY publishing never raises this: publishing twice in
     * a week is normal and supersedes nothing.
     */
    'week_occupied',
    /** Well formed, but violates a domain rule. */
    'unprocessable',
    /** Too many requests. */
    'rate_limited',
    /** Unhandled. Never carries detail to the caller. */
    'internal_error',
];
export function isErrorCode(v) {
    return typeof v === 'string' && ERROR_CODES.includes(v);
}
//# sourceMappingURL=errors.js.map